////////////////
//// BANNER ////
////////////////
function setupResponsiveBanner(selector) {
    let banner = document.querySelector(selector);

    // Si el banner no existe en la página, no hace nada
    if (!banner) return;

    let mobileWidth = 575.98;
    let imageUrlDesktop = banner.getAttribute('data-background-image-desktop');
    let imageUrlMobile = banner.getAttribute('data-background-image-mobile');

    function changeImage() {
        let viewportWidth = window.innerWidth;

        if (viewportWidth <= mobileWidth) {
            banner.style.backgroundImage = `url(${imageUrlMobile})`;
            banner.classList.add("bannertop__vertical");
        } else {
            banner.style.backgroundImage = `url(${imageUrlDesktop})`;
            banner.classList.remove("bannertop__vertical");
        }
    }

    changeImage();

    window.addEventListener('resize', changeImage);
}

// Aplicar la función a los dos banners
setupResponsiveBanner('.bannertop');
setupResponsiveBanner('.banner-reserve');

///////////////
//// VIDEO ////
///////////////
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mdl-video__it').forEach(container => {
        const video = container.querySelector('.mdl-video__player');
        const btn = container.querySelector('.mdl-video__bt');
        const title = container.closest('.mdl-video').querySelector('.mdl-video__titles');

        if (!video) return;

        let isPlaying = false;

        const playVideo = () => {
            video.play().catch(err => console.log(err));
            if (btn) btn.style.display = 'none';
            if (title) title.style.display = 'none';
            isPlaying = true;
        };

        const pauseVideo = () => {
            video.pause();
            if (btn) btn.style.display = 'block';
            if (title) title.style.display = 'block';
            isPlaying = false;
        };

        // Click en el botón
        if (btn) {
            btn.addEventListener('click', () => {
                playVideo();
            });
        }

        // Click sobre el vídeo
        video.addEventListener('click', () => {
            playVideo();
        });

        // Evento al finalizar el vídeo
        video.addEventListener('ended', () => {
            pauseVideo();
        });
    });
});

/////////////////////////
/// INSTANCIAS SWIPER ///
/////////////////////////
var swiperbannerbuy = new Swiper(".product", {
    slidesPerView: 1,
    spaceBetween: 0,
	loop: true,
    autoHeight: false,
    navigation: {
        nextEl: ".swiper-button-next.swiper-button-next-product",
        prevEl: ".swiper-button-prev.swiper-button-prev-product",
    },
    pagination: {
        el: ".swiper-pagination.swiper-pagination-product",
        clickable: true,
    },
});

/////////////////////
/// LANG SELECTOR ///
/////////////////////

document.addEventListener('DOMContentLoaded', function () { 
  let currentLang = document.querySelector('.sel-lang__c'); 
  let listLang = document.querySelector('.sel-lang__t'); 
  currentLang.addEventListener('click', function (e) { 
    this.classList.toggle('js-show'); 
    listLang.classList.toggle('js-show'); }); 
});